import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { isAnalyticalAllowed } from './lib/googleTagManagerConsent';

const { location } = window;

export type Env = 'local' | 'live' | 'unknown' | string;

export const envFromHostname = (hostname = location.hostname): Env => {
  if (/(localhost|dev\.|\.local)/.test(hostname)) {
    return 'local';
  }

  if (/raceroster\.com$/.test(hostname)) {
    return 'live';
  }

  const [, , envName] = /([a-zA-Z0-9]*\.){0,}([a-zA-Z0-9]*)\.rostrr\.net$/.exec(hostname) || [];
  if (envName) {
    return envName;
  }
  return 'unknown';
};

const env = envFromHostname();
const isLocalEnv = env === 'local';
let initialized = false;
let ddRumInitialized = false;
const SERVICE_NAME = 'photos-ui-public';

export const init = (): void => {
  if (!isLocalEnv && !initialized) {
    datadogLogs.init({
      clientToken: 'pub62fe231619e9e9dcb5cf8a61297513c5', // public token, okay in source code
      env,
      service: SERVICE_NAME,
    });
  }

  if (!isLocalEnv && !ddRumInitialized && isAnalyticalAllowed()) {
    datadogRum.init({
      applicationId: '3f58292b-07a2-4328-929b-bd8885c3c68b',
      clientToken: 'pub16e26791079cae24e6b9f951b8117302', // public token, okay in source code
      service: SERVICE_NAME,
      env,
      trackingConsent: 'granted',
      version: 'local',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 5,
      trackUserInteractions: true,
      silentMultipleInit: true,
      traceSampleRate: 100,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      allowedTracingUrls: [
        'http://photos-ui-app-1:5150',
        'https://photos.local.ue1dev1.rostrr.net:5177',
        'https://photos.prod.local.ue1dev1.rostrr.net:5150',
        'https://photos.raceroster.com',
        'https://raceroster.com',
        'https://ue1dev1.rostrr.net',
        'https://photos.ue1dev1.rostrr.net',
        'https://ue1dev2.rostrr.net',
        'https://photos.ue1dev2.rostrr.net',
      ],
    });
    datadogRum.startSessionReplayRecording();
    ddRumInitialized = true;
  }
  initialized = true;
};

export const logToDataDog = (message: string, context?: Record<string, any>): void => {
  if (!initialized) {
    throw new Error(
      'You need to initialize the ddTooling.ts file by calling the init function before logging a custom message.'
    );
  }
  if (!isLocalEnv) {
    datadogLogs.logger.log(message, context);
  } else {
    console.log(message, context);
  }
};
